import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { RouteDataService } from "../../services/route-data/route-data.service";
import { SessionService } from "../../services/session/session.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  env: any = environment;
  remainingTime: number;

  constructor(
    private authService: AuthService,
    private router: Router,
    public routeData: RouteDataService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    let currentDate = new Date();
    let endOfBeta = new Date("September 10, 2018 00:00:00");
    this.remainingTime = Math.floor(
      (endOfBeta.getTime() - currentDate.getTime()) / (24 * 3600 * 1000)
    );
  }

  logout() {
    this.authService.logout().then(() => {
      this.router.navigate(["/login"]);
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/header/header.component.ts